﻿import React, { forwardRef, ReactNode, useImperativeHandle, useRef, useState } from 'react';

import { GMetrixCheckInput } from 'components/GMetrixCheckInput/GMetrixCheckInput';

import 'components/GMetrixDialogPrompt/gmetrix-dialog-prompt.scss';

import { GMetrixButton } from 'components/GMetrixButton/GMetrixButton';
import { Modal, ModalDialogProps } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import { Variant } from 'react-bootstrap/esm/types';

export interface ButtonProps{
    buttonText?: string;
    closeButtonText?: string;
    hideCancel?: boolean;
    iconClass?: string;
    variant?: Variant;
}

interface CheckboxProps{
    label?: string;
    value?: boolean;
}

const GMetrixDialogConfirm = forwardRef((props, forwardRef) => {

    const { formatMessage } = useIntl();
    const [title, setTitle] = useState<ReactNode>(false);
    const [body, setBody] = useState<ReactNode>(false);
    const [confirmButtonProps, setConfirmButtonProps] = useState<ButtonProps>({ variant: 'primary' });
    const [modalProps, setModalProps] = useState<ModalDialogProps | undefined>({ size: undefined });
    const [checkboxProps, setCheckboxProps] = useState<CheckboxProps | undefined>({ value: false });
    const [showModal, setShowModal] = useState<boolean>(false);
    const resolveRef = useRef(null);
    const resolve: any = resolveRef?.current;

    const createConfirm = (
        title: ReactNode,
        body: ReactNode,
        confirmButtonProps?: ButtonProps,
        checkboxProps?: CheckboxProps,
        modalProps?: ModalDialogProps
    ) => new Promise(resolve => {

        (resolveRef.current as any) = resolve;

        setShowModal(true);
        setTitle(title);
        setBody(body);
        setModalProps(modalProps);
        if (confirmButtonProps){

            setConfirmButtonProps(confirmButtonProps);

        }
        setCheckboxProps(checkboxProps);

    });

    const closeSuccessfulDialog = () => {

        setShowModal(false);
        if (checkboxProps){

            resolve([true, checkboxProps.value]);

        } else {

            resolve(true);

        }

    };

    const closeDialog = () => {

        setShowModal(false);
        if (checkboxProps){

            resolve([null, checkboxProps.value]);

        } else {

            resolve(null);

        }

    };

    useImperativeHandle(forwardRef, () => ({
        confirm: createConfirm
    }), []);

    return (
        <Modal onHide={closeDialog} show={showModal} size={modalProps?.size}>
            {

                <Modal.Header closeButton>
                    <Modal.Title>
                        {title ? title : 'Notice'}
                    </Modal.Title>
                </Modal.Header>

            }
            <Modal.Body>
                {
                    typeof body === 'string'
                        ? (
                            <p>
                                {body}
                            </p>
                        )
                        : body
                }
            </Modal.Body>
            <Modal.Footer>

                {checkboxProps && (
                    <GMetrixCheckInput
                        onChange={e => {

                            setCheckboxProps({ ...checkboxProps, value: e.target.checked });

                        }}
                        checked={checkboxProps.value}
                        label={checkboxProps.label ?? formatMessage({ id: 'checkbox_label.c62b3678', defaultMessage: 'Checkbox Label' })}
                        type={'checkbox'}
                    />
                )}

                <GMetrixButton
                    className={`btn btn-sm`}
                    onClick={closeDialog}
                    style={{ minWidth: 82 }}
                    type='button'
                    variant='secondary'
                >
                    {confirmButtonProps.closeButtonText ?? <FormattedMessage defaultMessage="Cancel" id="cancel.89a86adc" />}
                </GMetrixButton>
                <GMetrixButton
                    className={`btn btn-sm`}
                    iconClass={confirmButtonProps.iconClass}
                    onClick={closeSuccessfulDialog}
                    style={{ minWidth: 82 }}
                    type='button'
                    variant={confirmButtonProps.variant}
                >
                    {confirmButtonProps.buttonText ?? <FormattedMessage defaultMessage="Confirm" id="confirm.297ab8f4" />}
                </GMetrixButton>

            </Modal.Footer>
        </Modal>
    );

});
GMetrixDialogConfirm.displayName = 'GMetrixDialogConfirm';
export default GMetrixDialogConfirm;